import Vue from "vue";
import Router from "vue-router";
const _import = require("./_import_" + process.env.NODE_ENV);
// in development env not use Lazy Loading,because Lazy Loading large page will cause webpack hot update too slow.so only in production use Lazy Loading

/* layout */
import Layout from "../views/layout/Layout";

/* login */
const Login = _import("login/login");
const ForcePassSet = _import("login/passSet");
const PassSet = _import("components/userSet/passReset");

/* dashboard */
const dashboard = _import("dashboard/index");

/* error page */
const Err404 = _import("404");

/* 系统设置 */

const MdelMent = _import("pgment/modelMent");
const UserMent = _import("pgment/userMent");
const RoleMent = _import("pgment/roleMent");
const DictMent = _import("pgment/dictMent");
const PublishMent = _import("pgment/publishMent");
const SectMent = _import("pgment/sectMent");
const SectStatic = _import("pgment/sectStatic");

/* 出版单位 */

const audioPs = _import("pressRole/Audio_Electronic/audioPress");
const electPs = _import("pressRole/Audio_Electronic/electPress");
const pgStep = _import("pressRole/Audio_Electronic/examProgress");
const deepSee = _import("pressRole/Audio_Electronic/skimFrame");
// 音像/电子核验进度历史
const pgStepHistory = _import("pressRole/Audio_Electronic/examProgressHistory");
// 连续型出版物核验进度历史
const successiveStepHistory = _import("pressRole/SuccessivePart/examProgressHistory");

const successivePs = _import("pressRole/SuccessivePart/successiveList");
const successiveTb = _import("pressRole/SuccessivePart/successiveTabs");
const successiveStep = _import("pressRole/SuccessivePart/examProgress");
const successiveRead = _import("pressRole/SuccessivePart/skimFrame");

const table1Edit = _import("pressRole/Audio_Electronic/forEdit/table1");
const table2Edit = _import("pressRole/Audio_Electronic/forEdit/table2");
const table3Edit = _import("pressRole/Audio_Electronic/forEdit/table3");
const table4Edit = _import("pressRole/Audio_Electronic/forEdit/table4");
const table5Edit = _import("pressRole/Audio_Electronic/forEdit/table5");
const table6Edit = _import("pressRole/Audio_Electronic/forEdit/table6");
const table7Edit = _import("pressRole/Audio_Electronic/forEdit/table7");
const table8Edit = _import("pressRole/Audio_Electronic/forEdit/table8");
const table9Edit = _import("pressRole/Audio_Electronic/forEdit/table9");
const table10Edit = _import("pressRole/Audio_Electronic/forEdit/table10");

const table4Tab = _import("pressRole/Audio_Electronic/forTabs/table4");
const table5Tab = _import("pressRole/Audio_Electronic/forTabs/table5");
const table6Tab = _import("pressRole/Audio_Electronic/forTabs/table6");
const table8Tab = _import("pressRole/Audio_Electronic/forTabs/table8");
const table9Tab = _import("pressRole/Audio_Electronic/forTabs/table9");

const ssTab1Edit = _import("pressRole/SuccessivePart/forEdit/ssTab1");
const ssTab2Edit = _import("pressRole/SuccessivePart/forEdit/ssTab2");
const ssTab3Edit = _import("pressRole/SuccessivePart/forEdit/ssTab3");
const ssTab4Edit = _import("pressRole/SuccessivePart/forEdit/ssTab4");
const ssTab5Edit = _import("pressRole/SuccessivePart/forEdit/ssTab5");

const ssTab4List = _import("pressRole/SuccessivePart/forTabs/ssTab4");

/* 省局 */

const audioEx = _import("provinceRole/audioPgress/audioList");
const audioRegister = _import("provinceRole/audioPgress/audioRegist");
const audioRpt = _import("provinceRole/audioPgress/audioReport");
const AudioSeek = _import("provinceRole/audioPgress/AudioPressSeek");

const electEx = _import("provinceRole/electPgress/electList");
const electRegister = _import("provinceRole/electPgress/electRegist");
const electRpt = _import("provinceRole/electPgress/electReport");

const examCeek = _import("provinceRole/Audio_Elect/commonTabs");
const provinceRpt = _import("provinceRole/Audio_Elect/commonReport");
const ElectSeek = _import("provinceRole/electPgress/ElectPressSeek");

const successiveEx = _import("provinceRole/successivePgress/successiveList");
const pvcSkimFrame = _import("provinceRole/successivePgress/successiveTabs");
const ssReport = _import("provinceRole/successivePgress/successiveReport");
const ssRegist = _import("provinceRole/successivePgress/successiveRegist");
const successiveSeek = _import("provinceRole/successivePgress/successivePressSeek");

/* 总局 */

const audioFEx = _import("adminRole/audioFExam");
const electFEx = _import("adminRole/electFExam");
const successiveFEx = _import("adminRole/successiveFExam");
const adminPck = _import("adminRole/adminPressck");
const adminssSuccessSkim = _import("adminRole/adminSuccessSkim");
const adminAudioSeek = _import("adminRole/AudioPressSeek");
const adminElectSeek = _import("adminRole/ElectPressSeek");
const adminSuccessiveSeek = _import("adminRole/successivePressSeek");
const adminPersonOperation = _import("adminRole/adminPersonOperation");
const adminPublishOperation = _import("adminRole/adminPublishOperation");
const adminBasicOperation = _import("adminRole/adminBasicOperation");
const chart1 = _import("adminRole/chart1");

/**zym.音像、电子上报情况统计 start */
const adminYxauditQuery = _import("adminRole/adminYxauditQuery");
const adminDzauditQuery = _import("adminRole/adminDzauditQuery");
/**zym.音像、电子上报情况统计 end */

/* 查看打印 */

const seekTab1 = _import("components/SPEC/glanceDcp/table1");
const seekTab2 = _import("components/SPEC/glanceDcp/table2");
const seekTab3 = _import("components/SPEC/glanceDcp/table3");
const seekTab4 = _import("components/SPEC/glanceDcp/table4");
const seekTab5 = _import("components/SPEC/glanceDcp/table5");
const seekTab6 = _import("components/SPEC/glanceDcp/table6");
const seekTab7 = _import("components/SPEC/glanceDcp/table7");
const seekTab8 = _import("components/SPEC/glanceDcp/table8");
const seekTab9 = _import("components/SPEC/glanceDcp/table9");
const seekTab209 = _import("components/SPEC/glanceDcp/table209");

const listTab4 = _import("components/SPEC/glanceTab/table4");
const listTab5 = _import("components/SPEC/glanceTab/table5");
const listTab6 = _import("components/SPEC/glanceTab/table6");
const listTab8 = _import("components/SPEC/glanceTab/table8");
const listTab9 = _import("components/SPEC/glanceTab/table9");

const skimTab1 = _import("components/SPEC/ssBlock/forEdit/ssTab1");
const skimTab2 = _import("components/SPEC/ssBlock/forEdit/ssTab2");
const skimTab3 = _import("components/SPEC/ssBlock/forEdit/ssTab3");
const skimTab4 = _import("components/SPEC/ssBlock/forEdit/ssTab4");
const skimTab5 = _import("components/SPEC/ssBlock/forEdit/ssTab5");

const ssListTab = _import("components/SPEC/ssBlock/forTabs/ssTab4");

// Vue.use(Router);

/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:noredirect` will not redirct in the levelbar
 * noDropdown : if `noDropdown:true` will not has submenu in the sidebar
 * meta : `{ role: ['admin'] }`  will control the page role
 **/
export const constantRouterMap = [
  { path: "/login", component: Login, hidden: true },
  { path: "/404", component: Err404, hidden: true },
  { path: "/paddSet", component: ForcePassSet, hidden: true },
  {
    path: "/",
    component: Layout,
    redirect: "/dashboard",
    name: "Home",
    hidden: true,
    children: [{ path: "dashboard", component: dashboard }],
  },
];

export default new Router({
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap,
});

// key必须对应数据库中的key否则不能注册路由
export const registerComponentMap = [
  {
    key: "press_role",
    component: Layout,
    parent: true,
    children: [
      {
        key: "audio_press",
        parent: false,
        component: audioPs,
      },
      {
        key: "elect_press",
        parent: false,
        component: electPs,
      },
      {
        key: "successive_press",
        parent: false,
        component: successivePs,
      },
      {
        key: "successive_tabs",
        parent: false,
        component: successiveTb,
      },
      {
        key: "successive_step",
        parent: false,
        component: successiveStep,
      },
      {
        key: "successive_read",
        parent: false,
        component: successiveRead,
      },
      {
        key: "pgress_step",
        parent: false,
        component: pgStep,
      },
      {
        key: "deep_see",
        parent: false,
        component: deepSee,
      },
      {
        key: "edit_tab1",
        parent: false,
        component: table1Edit,
      },
      {
        key: "edit_tab2",
        parent: false,
        component: table2Edit,
      },
      {
        key: "edit_tab3",
        parent: false,
        component: table3Edit,
      },
      {
        key: "edit_tab4",
        parent: false,
        component: table4Edit,
      },
      {
        key: "edit_tab5",
        parent: false,
        component: table5Edit,
      },
      {
        key: "edit_tab6",
        parent: false,
        component: table6Edit,
      },
      {
        key: "edit_tab7",
        parent: false,
        component: table7Edit,
      },
      {
        key: "edit_tab8",
        parent: false,
        component: table8Edit,
      },
      {
        key: "edit_tab9",
        parent: false,
        component: table9Edit,
      },
      {
        key: "edit_tab10",
        parent: false,
        component: table10Edit,
      },
      {
        key: "edit_ssTab1",
        parent: false,
        component: ssTab1Edit,
      },
      {
        key: "edit_ssTab2",
        parent: false,
        component: ssTab2Edit,
      },
      {
        key: "edit_ssTab3",
        parent: false,
        component: ssTab3Edit,
      },
      {
        key: "edit_ssTab4",
        parent: false,
        component: ssTab4Edit,
      },
      {
        key: "edit_ssTab5",
        parent: false,
        component: ssTab5Edit,
      },
      {
        key: "view_tab4",
        parent: false,
        component: table4Tab,
      },
      {
        key: "view_tab5",
        parent: false,
        component: table5Tab,
      },
      {
        key: "view_tab6",
        parent: false,
        component: table6Tab,
      },
      {
        key: "view_tab8",
        parent: false,
        component: table8Tab,
      },
      {
        key: "view_tab9",
        parent: false,
        component: table9Tab,
      },
      {
        key: "sstab4_list",
        parent: false,
        component: ssTab4List,
      },
      {
        key: "edsct_tab1",
        parent: false,
        component: seekTab1,
      },
      {
        key: "edsct_tab2",
        parent: false,
        component: seekTab2,
      },
      {
        key: "edsct_tab3",
        parent: false,
        component: seekTab3,
      },
      {
        key: "edsct_tab4",
        parent: false,
        component: seekTab4,
      },
      {
        key: "edsct_tab5",
        parent: false,
        component: seekTab5,
      },
      {
        key: "edsct_tab6",
        parent: false,
        component: seekTab6,
      },
      {
        key: "edsct_tab7",
        parent: false,
        component: seekTab7,
      },
      {
        key: "edsct_tab8",
        parent: false,
        component: seekTab8,
      },
      {
        key: "edsct_tab9",
        parent: false,
        component: seekTab9,
      },
      {
        key: "edsct_tab10",
        parent: false,
        component: seekTab209,
      },
      {
        key: "edlct_tab4",
        parent: false,
        component: listTab4,
      },
      {
        key: "edlct_tab5",
        parent: false,
        component: listTab5,
      },
      {
        key: "edlct_tab6",
        parent: false,
        component: listTab6,
      },
      {
        key: "edlct_tab8",
        parent: false,
        component: listTab8,
      },
      {
        key: "edlct_tab9",
        parent: false,
        component: listTab9,
      },
      {
        key: "ss_skimtab1",
        parent: false,
        component: skimTab1,
      },
      {
        key: "ss_skimtab2",
        parent: false,
        component: skimTab2,
      },
      {
        key: "ss_skimtab3",
        parent: false,
        component: skimTab3,
      },
      {
        key: "ss_skimtab4",
        parent: false,
        component: skimTab4,
      },
      {
        key: "ss_skimtab5",
        parent: false,
        component: skimTab5,
      },
      {
        key: "ss_listtab4",
        parent: false,
        component: ssListTab,
      },
    ],
  },
  {
    key: "province_role",
    component: Layout,
    parent: true,
    children: [
      {
        key: "audio_exam",
        parent: false,
        component: audioEx,
      },
      {
        key: "elect_exam",
        parent: false,
        component: electEx,
      },
      {
        key: "successive_exam",
        parent: false,
        component: successiveEx,
      },
      {
        key: "province_report",
        parent: false,
        component: provinceRpt,
      },
      {
        key: "ss_report",
        parent: false,
        component: ssReport,
      },
      {
        key: "audio_register",
        parent: false,
        component: audioRegister,
      },
      {
        key: "elect_register",
        parent: false,
        component: electRegister,
      },
      {
        key: "ss_regist",
        parent: false,
        component: ssRegist,
      },
      {
        key: "successive_skim",
        parent: false,
        component: pvcSkimFrame,
      },
      {
        key: "exam_check",
        parent: false,
        component: examCeek,
      },
      {
        key: "Audio_seek",
        parent: false,
        component: AudioSeek,
      },
      {
        key: "Elect_seek",
        parent: false,
        component: ElectSeek,
      },
      {
        key: "successive_seek",
        parent: false,
        component: successiveSeek,
      },
      {
        key: "edsct_tab1",
        parent: false,
        component: seekTab1,
      },
      {
        key: "edsct_tab2",
        parent: false,
        component: seekTab2,
      },
      {
        key: "edsct_tab3",
        parent: false,
        component: seekTab3,
      },
      {
        key: "edsct_tab4",
        parent: false,
        component: seekTab4,
      },
      {
        key: "edsct_tab5",
        parent: false,
        component: seekTab5,
      },
      {
        key: "edsct_tab6",
        parent: false,
        component: seekTab6,
      },
      {
        key: "edsct_tab7",
        parent: false,
        component: seekTab7,
      },
      {
        key: "edsct_tab8",
        parent: false,
        component: seekTab8,
      },
      {
        key: "edsct_tab9",
        parent: false,
        component: seekTab9,
      },
      {
        key: "edsct_tab10",
        parent: false,
        component: seekTab209,
      },
      {
        key: "edlct_tab4",
        parent: false,
        component: listTab4,
      },
      {
        key: "edlct_tab5",
        parent: false,
        component: listTab5,
      },
      {
        key: "edlct_tab6",
        parent: false,
        component: listTab6,
      },
      {
        key: "edlct_tab8",
        parent: false,
        component: listTab8,
      },
      {
        key: "edlct_tab9",
        parent: false,
        component: listTab9,
      },

      {
        key: "ss_skimtab1",
        parent: false,
        component: skimTab1,
      },
      {
        key: "ss_skimtab2",
        parent: false,
        component: skimTab2,
      },
      {
        key: "ss_skimtab3",
        parent: false,
        component: skimTab3,
      },
      {
        key: "ss_skimtab4",
        parent: false,
        component: skimTab4,
      },
      {
        key: "ss_skimtab5",
        parent: false,
        component: skimTab5,
      },
      {
        key: "ss_listtab4",
        parent: false,
        component: ssListTab,
      },
    ],
  },
  {
    key: "admin_role",
    component: Layout,
    parent: true,
    children: [
      {
        key: "audio_fexam",
        parent: false,
        component: audioFEx,
      },
      {
        key: "elect_fexam",
        parent: false,
        component: electFEx,
      },
      {
        key: "successive_fexam",
        parent: false,
        component: successiveFEx,
      },
      {
        key: "admin_fexam",
        parent: false,
        component: adminPck,
      },
      {
        key: "successive_skim",
        parent: false,
        component: adminssSuccessSkim,
      },

      /**zym.音像、电子上报情况统计 end */
      {
        key: "edsct_tab1",
        parent: false,
        component: seekTab1,
      },
      {
        key: "edsct_tab2",
        parent: false,
        component: seekTab2,
      },
      {
        key: "edsct_tab3",
        parent: false,
        component: seekTab3,
      },
      {
        key: "edsct_tab4",
        parent: false,
        component: seekTab4,
      },
      {
        key: "edsct_tab5",
        parent: false,
        component: seekTab5,
      },
      {
        key: "edsct_tab6",
        parent: false,
        component: seekTab6,
      },
      {
        key: "edsct_tab7",
        parent: false,
        component: seekTab7,
      },
      {
        key: "edsct_tab8",
        parent: false,
        component: seekTab8,
      },
      {
        key: "edsct_tab9",
        parent: false,
        component: seekTab9,
      },
      {
        key: "edsct_tab10",
        parent: false,
        component: seekTab209,
      },
      {
        key: "edlct_tab4",
        parent: false,
        component: listTab4,
      },
      {
        key: "edlct_tab5",
        parent: false,
        component: listTab5,
      },
      {
        key: "edlct_tab6",
        parent: false,
        component: listTab6,
      },
      {
        key: "edlct_tab8",
        parent: false,
        component: listTab8,
      },
      {
        key: "edlct_tab9",
        parent: false,
        component: listTab9,
      },
      {
        key: "ss_skimtab1",
        parent: false,
        component: skimTab1,
      },
      {
        key: "ss_skimtab2",
        parent: false,
        component: skimTab2,
      },
      {
        key: "ss_skimtab3",
        parent: false,
        component: skimTab3,
      },
      {
        key: "ss_skimtab4",
        parent: false,
        component: skimTab4,
      },
      {
        key: "ss_skimtab5",
        parent: false,
        component: skimTab5,
      },
      {
        key: "ss_listtab4",
        parent: false,
        component: ssListTab,
      },
    ],
  },
  // 出版社 - 核验进度查询
  {
    key: "cbs_examine_progress",
    parent: true,
    component: Layout,
    children: [
      {
        key: "cbs_examine_progress_yd",
        parent: false,
        component: pgStepHistory,
      },
      {
        key: "cbs_examine_progress_lxdz",
        parent: false,
        component: successiveStepHistory,
      },
      // 连续型出版物Tabs
      {
        key: "successive_tabs",
        parent: false,
        component: successiveTb,
      },
      {
        key: "successive_read",
        parent: false,
        component: successiveRead,
      },
      // {
      //   key: "pgress_step",
      //   parent: false,
      //   component: pgStep,
      // },
      {
        key: "deep_see",
        parent: false,
        component: deepSee,
      },
      {
        key: "edit_tab1",
        parent: false,
        component: table1Edit,
      },
      {
        key: "edit_tab2",
        parent: false,
        component: table2Edit,
      },
      {
        key: "edit_tab3",
        parent: false,
        component: table3Edit,
      },
      {
        key: "edit_tab4",
        parent: false,
        component: table4Edit,
      },
      {
        key: "edit_tab5",
        parent: false,
        component: table5Edit,
      },
      {
        key: "edit_tab6",
        parent: false,
        component: table6Edit,
      },
      {
        key: "edit_tab7",
        parent: false,
        component: table7Edit,
      },
      {
        key: "edit_tab8",
        parent: false,
        component: table8Edit,
      },
      {
        key: "edit_tab9",
        parent: false,
        component: table9Edit,
      },
      {
        key: "edit_tab10",
        parent: false,
        component: table10Edit,
      },
      {
        key: "edit_ssTab1",
        parent: false,
        component: ssTab1Edit,
      },
      {
        key: "edit_ssTab2",
        parent: false,
        component: ssTab2Edit,
      },
      {
        key: "edit_ssTab3",
        parent: false,
        component: ssTab3Edit,
      },
      {
        key: "edit_ssTab4",
        parent: false,
        component: ssTab4Edit,
      },
      {
        key: "edit_ssTab5",
        parent: false,
        component: ssTab5Edit,
      },
      {
        key: "view_tab4",
        parent: false,
        component: table4Tab,
      },
      {
        key: "view_tab5",
        parent: false,
        component: table5Tab,
      },
      {
        key: "view_tab6",
        parent: false,
        component: table6Tab,
      },
      {
        key: "view_tab8",
        parent: false,
        component: table8Tab,
      },
      {
        key: "view_tab9",
        parent: false,
        component: table9Tab,
      },
      {
        key: "sstab4_list",
        parent: false,
        component: ssTab4List,
      },
      {
        key: "edsct_tab1",
        parent: false,
        component: seekTab1,
      },
      {
        key: "edsct_tab2",
        parent: false,
        component: seekTab2,
      },
      {
        key: "edsct_tab3",
        parent: false,
        component: seekTab3,
      },
      {
        key: "edsct_tab4",
        parent: false,
        component: seekTab4,
      },
      {
        key: "edsct_tab5",
        parent: false,
        component: seekTab5,
      },
      {
        key: "edsct_tab6",
        parent: false,
        component: seekTab6,
      },
      {
        key: "edsct_tab7",
        parent: false,
        component: seekTab7,
      },
      {
        key: "edsct_tab8",
        parent: false,
        component: seekTab8,
      },
      {
        key: "edsct_tab9",
        parent: false,
        component: seekTab9,
      },
      {
        key: "edsct_tab10",
        parent: false,
        component: seekTab209,
      },
      {
        key: "edlct_tab4",
        parent: false,
        component: listTab4,
      },
      {
        key: "edlct_tab5",
        parent: false,
        component: listTab5,
      },
      {
        key: "edlct_tab6",
        parent: false,
        component: listTab6,
      },
      {
        key: "edlct_tab8",
        parent: false,
        component: listTab8,
      },
      {
        key: "edlct_tab9",
        parent: false,
        component: listTab9,
      },
      {
        key: "ss_skimtab1",
        parent: false,
        component: skimTab1,
      },
      {
        key: "ss_skimtab2",
        parent: false,
        component: skimTab2,
      },
      {
        key: "ss_skimtab3",
        parent: false,
        component: skimTab3,
      },
      {
        key: "ss_skimtab4",
        parent: false,
        component: skimTab4,
      },
      {
        key: "ss_skimtab5",
        parent: false,
        component: skimTab5,
      },
      {
        key: "ss_listtab4",
        parent: false,
        component: ssListTab,
      },
    ],
  },
  {
    key: "admin_seek_publish",
    parent: true,
    component: Layout,
    children: [
      {
        key: "admin_audio_seek",
        parent: false,
        component: adminAudioSeek,
      },
      {
        key: "admin_elect_seek",
        parent: false,
        component: adminElectSeek,
      },
      {
        key: "admin_successive_seek",
        parent: false,
        component: adminSuccessiveSeek,
      },
      /**zym.音像、电子上报情况统计 start */
      {
        key: "admin_yxaudit_query",
        parent: false,
        component: adminYxauditQuery,
      },
      {
        key: "admin_dzaudit_query",
        parent: false,
        component: adminDzauditQuery,
      },

      /**zym.音像、电子上报情况统计 end */
      {
        key: "admin_fexam",
        parent: false,
        component: adminPck,
      },
      {
        key: "edsct_tab1",
        parent: false,
        component: seekTab1,
      },
      {
        key: "edsct_tab2",
        parent: false,
        component: seekTab2,
      },
      {
        key: "edsct_tab3",
        parent: false,
        component: seekTab3,
      },
      {
        key: "edsct_tab4",
        parent: false,
        component: seekTab4,
      },
      {
        key: "edsct_tab5",
        parent: false,
        component: seekTab5,
      },
      {
        key: "edsct_tab6",
        parent: false,
        component: seekTab6,
      },
      {
        key: "edsct_tab7",
        parent: false,
        component: seekTab7,
      },
      {
        key: "edsct_tab8",
        parent: false,
        component: seekTab8,
      },
      {
        key: "edsct_tab9",
        parent: false,
        component: seekTab9,
      },
      {
        key: "edsct_tab10",
        parent: false,
        component: seekTab209,
      },
      {
        key: "edlct_tab4",
        parent: false,
        component: listTab4,
      },
      {
        key: "edlct_tab5",
        parent: false,
        component: listTab5,
      },
      {
        key: "edlct_tab6",
        parent: false,
        component: listTab6,
      },
      {
        key: "edlct_tab8",
        parent: false,
        component: listTab8,
      },
      {
        key: "edlct_tab9",
        parent: false,
        component: listTab9,
      },
      {
        key: "ss_skimtab1",
        parent: false,
        component: skimTab1,
      },
      {
        key: "ss_skimtab2",
        parent: false,
        component: skimTab2,
      },
      {
        key: "ss_skimtab3",
        parent: false,
        component: skimTab3,
      },
      {
        key: "ss_skimtab4",
        parent: false,
        component: skimTab4,
      },
      {
        key: "ss_skimtab5",
        parent: false,
        component: skimTab5,
      },
      {
        key: "ss_listtab4",
        parent: false,
        component: ssListTab,
      },

      {
        key: "successive_skim",
        parent: false,
        component: adminssSuccessSkim,
      },
    ],
  },
  {
    key: "admin_seek_info",
    component: Layout,
    parent: true,
    children: [
      {
        key: "admin_basic_operation",
        parent: false,
        component: adminBasicOperation,
      },
      {
        key: "admin_person_operation",
        parent: false,
        component: adminPersonOperation,
      },
      {
        key: "admin_publish_operation",
        parent: false,
        component: adminPublishOperation,
      },
    ],
  },
  {
    key: "admin_statistical_analysis",
    component: Layout,
    parent: true,
    children: [
      {
        key: "chart1",
        parent: false,
        component: chart1,
      },
    ],
  },
  {
    key: "ss_ment",
    component: Layout,
    parent: true,
    children: [
      {
        key: "sect_ment",
        parent: false,
        component: SectMent,
      },
      {
        key: "user_ment",
        parent: false,
        component: UserMent,
      },
      {
        key: "role_ment",
        parent: false,
        component: RoleMent,
      },
      {
        key: "dict_ment",
        parent: false,
        component: DictMent,
      },
      {
        key: "publish_ment",
        parent: false,
        component: PublishMent,
      },
      {
        key: "model_ment",
        parent: false,
        component: MdelMent,
      },
      {
        key: "sect_static",
        parent: false,
        component: SectStatic,
      },
    ],
  },
  { key: "pass_set", noDropdown: true, component: Layout, childrenComponent: PassSet },
];



// WEBPACK FOOTER //
// ./src/router/index.js